window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('webpack-jquery-ui');
    require('../vendor/inspinia/inspinia.js');
} catch (e) {}

import Pusher from "pusher-js";

window.Vue = require('vue');

window.__ = (string, args) => {
    let value = _.get(window.i18n, string);

    _.eachRight(args, (paramVal, paramKey) => {
        value = _.replace(value, `:${paramKey}`, paramVal);
    });

    if (!value) {
        return string;
    }

    return value;
};

window.trans_choice = (string, cnt, args) => {
    let variants = _.split(window.__(string, _.merge(args, {'count': cnt})), '|');
    let singular = variants[0];
    let plural = variants[1] || singular;

    if (cnt === 1) {
        return singular;
    }

    return plural;
};

require('babel-polyfill'); // IE 11 issues
require('es6-promise').polyfill(); // IE 11 issues
window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': Scoop.csrfToken
};

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': Scoop.csrfToken
    }
});

Vue.prototype.$http = axios;
Vue.prototype.__ = (string, args) => {
    let value = _.get(window.i18n, string);

    _.eachRight(args, (paramVal, paramKey) => {
        value = _.replace(value, `:${paramKey}`, paramVal);
    });

    if (!value) {
        return string;
    }

    return value;
};
Vue.prototype.trans_choice = (string, cnt, args) => {
    let variants = _.split(window.__(string, _.merge(args, {'count': cnt})), '|');
    let singular = variants[0];
    let plural = variants[1] || singular;

    if (cnt === 1) {
        return singular;
    }

    return plural;
};

require('bootstrap-editable');
require('bootstrap-touchspin');
require('icheck');
require('jstree');
require('metismenu');
require('select2');

window.chartist = require('chartist');
window.ClipboardJS = require('clipboard');
window.DragSelect = require('dragselect');
window.Dropzone = require('dropzone');
window.Flatpickr = require('flatpickr');
window.toastr = require('toastr');
window.URI = require('urijs');

try {
    window.Pace = require('pace-js');
    Pace.start();
} catch (e) {}
